import {Component, OnInit} from '@angular/core';
import {AuthService, notify} from 'shared';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-recovery-change-password-form',
  templateUrl: './recovery-change-password-form.component.html',
  styleUrls: ['./recovery-change-password-form.component.scss']
})
export class RecoveryChangePasswordFormComponent implements OnInit {
  password = '';
  private token: string;
  loadIndicatorVisible = false;

  constructor(private authService: AuthService, private route: ActivatedRoute, private router: Router) {
    this.passwordValue = this.passwordValue.bind(this);
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParams?.token;
  }

  onChangeClick(args) {
    if (!args.validationGroup.validate().isValid || !this.token) {
      return;
    }
    this.loadIndicatorVisible = true;

    this.authService.recoveryChangePassword({new_password: this.password, token: this.token}).subscribe(
      () => {
        notify('Le mot de passe a été changé avec succès.', 'success');
        this.loadIndicatorVisible = false;
        this.router.navigate(['/login']);
      }, () => {
        notify('Désolé, une erreur est survenue. Veuillez réessayer.', 'warning');
        this.loadIndicatorVisible = false;
      });

  }

  passwordValue() {
    return this.password;
  }

}
